import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Divider,
    FormControl,
    FormLabel,
    Grid,
    Typography
} from "@mui/material";
import { useCallback, useEffect, useMemo, useState,useRef } from "react";
import { LoadingButton } from "@mui/lab";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";

// Components
import { CheckGreen, DownIcon, InfoIcon } from "../../../../../assets/common-svg/CommonSvg";
import FormikArrayInBound from "../../../../../pages/appointment-details/common-in-bound/FormikArrayInBound";
import FormikControl from "../../../../components/common/FormikControl";

// Redux
import {
    createOutbondForm,
    fetchOutbondDetails,
    fetchPreFilledData,
    selectIsSubmitLoading,
    updateOutbondForm,
    qaVerificationComment
} from "../../../../slices/outbound";
import { selectCurrentCycle, selectAllInitialSteps } from "../../../../slices/common";

// Utils and Constants
import { dateFormater } from "../../../../utils/common/utils";
import {
    confirmationOptions
} from "../../../../../pages/appointment-details/common-in-bound/common";
import { PrimaryOptions } from "../../../../../pages/appointment-details/common-pre-screen/common";
import {
    INITIAL_VALUES_1,
    INITIAL_VALUES_2,
    STATUS_COMPLETED,
    // STATUS_IN_PROGRESS,
    // STATUS_PENDING,
    // STATUS_SUBMITED,
    STEP_SLUGS,
    validationSchemaOutbondPart1,
    validationSchemaOutbondPart2
} from "./common";
import moment from "moment";
import { useReactToPrint } from 'react-to-print';
import QrAllPrintContent from '../../InBound/QrAllPrintContent'
import { selectDropDownDataMaster, fetchManufecturingButtonDropDown } from "../../../../slices/customMaster"


const OutBoundForm = ({ subjectId, updateTimeLine, printPatientInfo={}, }) => {
    const dispatch = useDispatch();
    const printContentAllRef = useRef(null)
    const printTimeoutAllRef = useRef(null)
    const { role_id,role_slug } = useSelector((state) => state.loginData);
    const isSubmitLoading = useSelector(selectIsSubmitLoading);
    const allInitialSteps = useSelector(selectAllInitialSteps);
    const currentCycle = useSelector(selectCurrentCycle)
    const [commentStatus, setCommentStatus] = useState(true)
    const [allPrintData, setAllPrintData] = useState({})
    const isOutBoundPrint = ['superadmin','editor','project-manager']?.includes(role_slug)
    const [isDraft, setIsDraft] = useState(false);
    const equipmentOptions = useSelector(selectDropDownDataMaster('equipment'))

    const reactToPrintFnAll = useReactToPrint({
    content: () => printContentAllRef.current,
  }); 

     useEffect(() => {
        dispatch(fetchManufecturingButtonDropDown('equipment'))
    },[])

    const [outbondFormExpanded, setOutboundFormExpanded] = useState(true);
  // Memoized step status checks
    const { checkOutbondPart1Enable, checkOutbondPart2Enable, checkOutbondSubmitEnable, qaOutbondForm } = useMemo(() => {
        const qualityControlStep = allInitialSteps?.find(
            step => step.slug === STEP_SLUGS.QUALITY_CONTROL
        );

        const productShippedStatus = allInitialSteps?.find(
            step => step.slug === STEP_SLUGS.PRODUCT_SHIPPED
        );
       const productShippedReceieved = allInitialSteps?.find(
            step => step.slug === STEP_SLUGS.PRODUCT_RECEIVED
        );
        const productShipped = allInitialSteps?.find(
            step => step.slug === STEP_SLUGS.INFUSION
        );
        
        return {
            checkOutbondPart1Enable: qualityControlStep?.status === STATUS_COMPLETED,
            // part1buttonDisable: productShippedStatus?.status >= STATUS_IN_PROGRESS,
            // part2buttonDisable: productInfusionStatus?.status != STATUS_SUBMITED && productInfusionStatus?.status != STATUS_PENDING,
            // productSubmited: productInfusionStatus?.status == STATUS_SUBMITED,
            checkOutbondPart2Enable: productShippedStatus?.status === STATUS_COMPLETED && (role_id == 5 ||  role_slug === "project-manager"),
            checkOutbondSubmitEnable: productShippedReceieved?.status === STATUS_COMPLETED && (role_id == 5 ||  role_slug === "project-manager"),
            qaOutbondForm: productShipped?.status === STATUS_COMPLETED && role_slug == 'quality-associate'
        };
    }, [allInitialSteps]);

      const handleOutPrint = (fields, values) =>{

         if (printTimeoutAllRef.current) {
    clearTimeout(printTimeoutAllRef.current);
    printTimeoutAllRef.current = null;
  }

    setAllPrintData({fields, values, printPatientInfo,title:"Out-Bound Form"})
        printTimeoutAllRef.current = setTimeout(() => {
          reactToPrintFnAll();
          // Clear the timeout reference after execution
          printTimeoutAllRef.current = null;
        }, 100);
    }

    useEffect(() => {
  return () => {
    if (printTimeoutAllRef.current) {
      clearTimeout(printTimeoutAllRef.current);
    }
  };
}, []);

const handlePrintOutbound = () =>{
    handleOutPrint(formFieldsPrint,formik?.values)
  }

   const [outboundInitialValues, setOutboundInitialValues] = useState(() => {
        if (checkOutbondPart1Enable && checkOutbondPart2Enable) {
            return { ...INITIAL_VALUES_1, ...INITIAL_VALUES_2 };
        } else if (checkOutbondPart1Enable) {
            return INITIAL_VALUES_1;
        } else if (checkOutbondPart2Enable) {
            return INITIAL_VALUES_2;
        }
        return {}; // default empty object if neither is enabled
    });

    // Optimized data fetching functions
    const getOutboundFilledData = useCallback(async () => {
        if(!subjectId) return;
         const data = {
          product_manufacturing_id: currentCycle?.product_manufacturing_id,
          feasibility_assesment_id: currentCycle?.feasibility_assessments_id,
          patient_id:subjectId
         }
        try {
            const res = await dispatch(fetchPreFilledData(data)).unwrap();
            if (res.status === 200) {
                setOutboundInitialValues(prevValues => ({
                    ...prevValues,
                    ...res.data,
                    batch_no: currentCycle?.batch_no,
                    full_name: `${res.data?.first_name} ${res.data?.last_name}`,
                    dob: res.data?.dob ? dateFormater(res.data?.dob) : "",
                    date_of_dispatch_of_finished_product: res.data?.date_of_dispatch_of_finished_product
                        ? dateFormater(res.data?.date_of_dispatch_of_finished_product) : "",
                    manufacturing_date: res.data?.manufacturing_date
                        ? dateFormater(res.data?.manufacturing_date) : "",
                    expiry_date: res.data?.expiry_date
                        ? dateFormater(res.data?.expiry_date) : "",
                    verified_by_date: res.data?.verified_by_date
                        ? dateFormater(res.data?.verified_by_date) : "",
                    handover_to_date: res.data?.handover_to_date
                        ? dateFormater(res.data?.handover_to_date) : "",
                    volume_in_each_bag: res.data?.volume_in_each_bag
                        ? JSON.parse(res.data?.volume_in_each_bag) : [],
                    used_blood: '100',
                     created_at: res.data?.created_at
                        ? dateFormater(res.data?.created_at) : "",
                        dispatched_by_date:res.data?.dispatched_by_date
                        ? dateFormater(res.data?.dispatched_by_date) : "", //@info formatDateMoment is removed date is coming formatted.
                }));
               
            }
        } catch (error) {
            console.error("Error fetching prefilled data:", error);
        }
    }, [dispatch, subjectId,currentCycle]);

    const getOutbondFormDetails = useCallback(async () => {
        if (!currentCycle?.outbound_form_id) return;
        try {
            const res = await dispatch(fetchOutbondDetails(currentCycle?.outbound_form_id)).unwrap();

            if (res.status === 200) {
                setOutboundInitialValues(prevValues => ({
                    ...prevValues,
                    ...res.data,
                 status: currentCycle?.outbound_form_id ? res.data?.status : 0,
                    receipt_date: res.data?.receipt_date
                        ? dateFormater(res.data?.receipt_date) : "",
                    receipt_received_by_date: res.data?.receipt_received_by_date
                        ? dateFormater(res.data?.receipt_received_by_date) : "",
                    receipt_verified_by_date: res.data?.receipt_verified_by_date
                        ? dateFormater(res.data?.receipt_verified_by_date) : "",
                    comment : res.data?.qa_verified_comment,
                    receipt_time: res?.data?.receipt_time ? res.data?.receipt_time?.split(":")?.slice(0, 2)?.join(":"):'',
                }));
                  if(res.data?.qa_verified_comment)
                  setCommentStatus(false)
            }
        } catch (error) {
            console.error("Error fetching outbound form details:", error);
        }
    }, [dispatch, currentCycle?.outbound_form_id]);

 
        const { disabledAllItem } = useMemo(() => {
        const infusionDateFilledStatus = allInitialSteps?.find(
            step => step.slug === STEP_SLUGS.INFUSION
        );
        return {
            disabledAllItem : outboundInitialValues?.status >= 1 || !infusionDateFilledStatus?.infusion_date,
        };
        }, [allInitialSteps,outboundInitialValues]);

        const [finalInitialization] = useState(outboundInitialValues);

       useEffect(() => {
        if(currentCycle?.outbound_form_id){
            getOutbondFormDetails()
        }else{
         setOutboundInitialValues(prev => ({ ...prev, ...finalInitialization, status: 0  }));
        }
      }, [getOutbondFormDetails, currentCycle]);

    // Load data on mount and when subjectId changes
    useEffect(() => {
    getOutboundFilledData()
    }, [getOutboundFilledData,currentCycle]);

    // Optimized submit handler
    const handleSubmitPart1 = useCallback(async (values, isDraft) => {
        try {
            const data = {
                patient_id: subjectId,
                formData: {
                    feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                    product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
                    dispatch_temperature: values?.dispatch_temperature,
                    dispatch_time: values?.dispatch_time,
                    outbound_id:currentCycle?.outbound_form_id,
                    status: isDraft ? 'draft' : 'submit',
                }
            };
            await dispatch(createOutbondForm(data));
            await getOutboundFilledData();
            await updateTimeLine();
            setOutboundFormExpanded(false);
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    }, [dispatch, subjectId, getOutboundFilledData, updateTimeLine, currentCycle]);

      const handleSubmitQaRemark = useCallback(async (values) => {
        try {
            const data = {
                patient_id: currentCycle?.outbound_form_id,
                formData: {
                    comment: values?.comment
                }
            };
            await dispatch(qaVerificationComment(data));
            await getOutbondFormDetails();
            setOutboundFormExpanded(false);
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    }, [dispatch, currentCycle, getOutbondFormDetails]);


    // Optimized submit handler
    const handleSubmitPart2 = useCallback(async (values, isDraft) => {
        try {
            const data = {
                patient_id: subjectId,
                id:currentCycle?.outbound_form_id,
                formData: {
                    ...values,
                    feasibility_assesment_id: currentCycle?.feasibility_assessments_id,
                    product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
                    receipt_date: values?.receipt_date ? moment(values?.receipt_date, "DD/MM/YYYY").format():'',
                     status: isDraft ? 'draft' : 'submit',
                }
            };
            await dispatch(updateOutbondForm(data));
            await getOutboundFilledData();
            await getOutbondFormDetails();
            await updateTimeLine();
            setOutboundFormExpanded(false);
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    }, [dispatch, subjectId, getOutboundFilledData, updateTimeLine, currentCycle]);

    // Validation schema based on enabled parts
    const validationSchema = useMemo(() => {
        if (checkOutbondPart1Enable) {
            return validationSchemaOutbondPart1(isDraft);
        }
        if (checkOutbondPart2Enable) {
            return validationSchemaOutbondPart2(isDraft);
        }
        return null;
    }, [checkOutbondPart1Enable, checkOutbondPart2Enable, isDraft]);

    // Formik configuration
    const formik = useFormik({
        initialValues: outboundInitialValues,
        validationSchema,
        validateOnBlur: false,
        enableReinitialize: true,
            onSubmit: (values) => {
        if (qaOutbondForm) {
            return handleSubmitQaRemark(values);
        } else if (checkOutbondPart1Enable) {
            return handleSubmitPart1(values, isDraft);
        } else if ((role_id == 5 ||  role_slug === "project-manager") && checkOutbondPart2Enable) {
            return handleSubmitPart2(values, isDraft);
        }
    },
    });

        // Memoized form configuration
    const outBoundFormValuesPart1Print = useMemo(() => [
        { section:"Patient & Collection Details" },
        {
            label: "Hospital Name",
            type: "text",
            name: "hospital_name",
            placeholder: "Enter Hospital Name",
            disabled: true,
            col: 2,
        },
        {
            label: "Hospital Patient ID",
            type: "text",
            name: "hospital_patient_id",
            placeholder: "Enter Hospital Patient ID",
            required: true,
            disabled: true,
            noQuery: true,
            col: 4,
            isFirstPartField: true,
        },
        {
            label: "ImmunoACT Patient ID",
            type: "text",
            name: "patient_id",
            placeholder: "Enter ImmunoACT Patient ID",
            disabled: true,
            noQuery: true,
            col: 4,
            isFirstPartField: true,
        },
        {
            label: "Patient Full Name",
            type: "text",
            name: "full_name",
            placeholder: "Enter Patient Full Name",
            disabled: true,
            noQuery: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Patient Initials",
            type: "text",
            name: "sub_initials",
            placeholder: "Enter Patient Initials",
            noQuery: true,
            disabled: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Date of Birth",
            type: "text",
            name: "dob",
            placeholder: "Enter Date of Birth",
            disabled: true,
            noQuery: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Disease Indication",
            type: "text",
            name: "disease_name",
            placeholder: "Enter Disease Indication",
            disabled: true,
            noQuery: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Patient Weight(Kg)",
            type: "number",
            disabled: true,
            name: "patient_weight",
            placeholder: "Enter Patient Weight (Kg)",
            required: true,
            col: 3,
        },
        {
            label: "Patient Weight Submitted",
            type: "text",
            disabled: true,
            name: "created_at",
            required: true,
            col: 3,
        },
        {
            label: "Batch Number",
            type: "text",
            disabled: true,
            name: "batch_no",
            placeholder: "Enter Batch Number",
            required: true,
            col: 3,
        },
        { section: "Time & Temperature at finish product dispatch" },
        {
            label: "Manufacturing date",
            type: "text",
            name: "manufacturing_date",
            disabled: true,
            placeholder: "Enter Manufacturing date",
            required: true,
            col: 3,
        },
        {
            label: "Expiry Date",
            type: "text",
            name: "expiry_date",
            disabled: true,
            placeholder: "Enter Expiry Date",
            required: true,
            col: 3,
        },
        {
            label: "Quantity (Number of Bags)",
            type: "number",
            disabled: true,
            name: "number_of_bags",
            placeholder: "Enter Quantity (number of bags)",
            required: true,
            col: 3,
        },
        {
            label: "Volume(ml)",
            type: "text",
            disabled: true,
            name: "used_blood",
            placeholder: "Volume used",
            required: false,
            col: 2,
        },
        {
            label: "COA",
            type: "radio",
            name: "has_coa_form",
            options: PrimaryOptions,
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Mode of Dispatch",
            type: "text",
            name: "mode_of_dispatch",
            placeholder: "Select Mode of Dispatch",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Serial No",
            type: "text",
            disabled: true,
            name: "data_logger_serial_no",
            placeholder: "Enter Data Logger Serial No",
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Equipment ID",
            disabled: true,
            type: "select",
            name: "equipment_id",
            placeholder: "Select Equipment ID",
            options: equipmentOptions,
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Date of Dispatch of Finish Product",
            type: "date",
            name: "date_of_dispatch_of_finished_product",
            placeholder: "Select Date of Dispatch",
            disabled: disabledAllItem,
            required: true,
           // min: new Date(),
            inputClassName: "!py-[13px] !px-[13px]",
            col: 1,
            isFirstPartField: true,
        },
        {
            label: "Temperature at Dispatch (°C)",
            type: "number",
            name: "dispatch_temperature",
            placeholder: "Enter Temperature at Dispatch (°C)",
            isTempratureField: true,
            disabled: disabledAllItem,
            min: -80,
            required: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Time of Dispatch",
            type: "time",
            name: "dispatch_time",
            placeholder: "Select Time of Dispatch",
            disabled: disabledAllItem,
            required: true,
            col: 2,
            isFirstPartField: true,
        },
     
    ], [outboundInitialValues, disabledAllItem]);

   const outBoundFormValuesPart2Print = useMemo(() => [
        { section: "Dispatched By" },
        {
            label:'Dispatched By Name',
            type: "text",
            name: "dispatched_by_sign",
            placeholder: "Select Time of Dispatch",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            type: "text",
            label:'Dispatched Date',
            name: "dispatched_by_date",
            placeholder: "Select Time of Dispatch",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        { section:"Receipt & Verification (IA Warehouse/Logistics/QA)" },
        {
            name: "patient_details_verified",
            label: "Patient details verified",
            type: "radio",
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            required: true,
            col: 2,
        },
        {
            name: "receipt_date",
            label: "Date of receipt",
            type: "date",
            required: true,
            disabled: formik.values?.status == 2,
            placeholder: "Select Date of Receipt",
            min: new Date().toISOString().split("T")[0],
            max: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
            inputClassName: "!py-[13px] !px-[13px]",
            col: 2,
        },
        { section: "Physical integrity of transport box and product to be checked" },
        {
            name: "leakage_observed",
            label: "Leakage",
            type: "radio",
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            required: true,
            col: 2,
        },
        {
            name: "leakage_observed_comment",
            type: "textarea",
            label: "Leakage 's Comment",
            depend: "leakage_observed",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        {
            name: "broken_seal",
            label: "Broken Seal",
            type: "radio",
            required: true,
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            col: 2,
        },
        {
            name: "broken_seal_comment",
            type: "textarea",
            label: "Broken Seal 's Comment",
            depend: "broken_seal",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        {
            name: "broken_transport_box",
            label: "Broken Transport Box",
            type: "radio",
            required: true,
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            col: 2,
        },
         {
            name: "broken_transport_box_comment",
            type: "textarea",
            label: "Broken Transport Box 's Comment",
            depend: "broken_transport_box",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        { section: "Time & Temperature at receipt of Finished Product" },
         {
                name: "temperature_excursion",
                label: "Temperature Excursion",
                type: "radio",
                required: true,
                options: confirmationOptions,
                disabled: formik.values?.status == 2,
                col: 2,
                isResolve: ["quality-check"],
         },
        {
            name: "temperature_excursion_comment",
            type: "textarea",
            label: "Temperature Excursion 's Comment",
            depend: "temperature_excursion",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        {
            name: "receipt_temperature",
            label: "Excursion Temperature (°C)",
            type: "number",
            depend: "temperature_excursion",
            dependValue: "true",
            disabled: formik.values?.status == 2,
            required: true,
            placeholder: "Enter Excursion Temperature",
            isTempratureField: true,
            min: -80,
            max: 30,
            col: 2,
        },
             {
            name: "excursion_duration",
            label: "Excursion Duration (HH:MM)",
            type: "text",
            required: true,
            placeholder: "e.g. 48:30",
            disabled: formik.values?.status == 2,
            depend: "temperature_excursion",
            dependValue: "true",
            col: 2,
        },
        {
            name: "receipt_time",
            label: "Excursion Time",
            type: "time",
            depend: "temperature_excursion",
            dependValue: "true",
            disabled: formik.values?.status == 2,
            required: true,
            placeholder: "Select Excursion Time",
            col: 2,
        },
        { section: "Quantity Received (Number of Bags)" },
        {
            name: "quantity_received",
            type: "number",
            label: "Number of Bags",
            disabled: formik.values?.status == 2,
            placeholder: "Enter Quantity Received",
            required: true,
            col: 1,
        },
        { section: "Received By" },
        {
            type: "text",
            label: "Received By Name",
            name: "receipt_received_by_name",
            placeholder: "Enter the receiver name",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            type: "text",
             label: "Received Date",
            name: "receipt_received_by_date",
            placeholder: "Enter the receiver sign & date",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        { section: "Receipt Verified By" },
        {
            type: "text",
            label: "Received Verified By Name",
            name: "receipt_verified_by_name",
            placeholder: "Enter the verifier name",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            type: "text",
            name: "receipt_verified_by_date",
            label: "Received Verified By Date",
            placeholder: "Enter the verifier sign & date",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
    ], [formik.values]);


    // Memoized form configuration
    const outBoundFormValuesPart1 = useMemo(() => [
        { section: "PATIENT & COLLECTION DETAILS" },
        {
            label: "Hospital Name",
            type: "text",
            name: "hospital_name",
            placeholder: "Enter Hospital Name",
            disabled: true,
            col: 2,
        },
        {
            label: "Hospital Patient ID",
            type: "text",
            name: "hospital_patient_id",
            placeholder: "Enter Hospital Patient ID",
            required: true,
            disabled: true,
            noQuery: true,
            col: 4,
            isFirstPartField: true,
        },
        {
            label: "ImmunoACT Patient ID",
            type: "text",
            name: "patient_id",
            placeholder: "Enter ImmunoACT Patient ID",
            disabled: true,
            noQuery: true,
            col: 4,
            isFirstPartField: true,
        },
        {
            label: "Patient Full Name",
            type: "text",
            name: "full_name",
            placeholder: "Enter Patient Full Name",
            disabled: true,
            noQuery: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Patient Initials",
            type: "text",
            name: "sub_initials",
            placeholder: "Enter Patient Initials",
            noQuery: true,
            disabled: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Date of Birth",
            type: "text",
            name: "dob",
            placeholder: "Enter Date of Birth",
            disabled: true,
            noQuery: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Disease Indication",
            type: "text",
            name: "disease_name",
            placeholder: "Enter Disease Indication",
            disabled: true,
            noQuery: true,
            col: 3,
            isFirstPartField: true,
        },
        {
            label: "Patient Weight(kg)",
            type: "number",
            disabled: true,
            name: "patient_weight",
            placeholder: "Enter Patient Weight (kg)",
            required: true,
            col: 3,
        },
        {
            label: "Batch Number",
            type: "text",
            disabled: true,
            name: "batch_no",
            placeholder: "Enter Batch Number",
            required: true,
            col: 3,
        },
        { section: "Time and Temperature at the time of dispatch of the product in the transport box (24-hour format)" },
        {
            label: "Manufacturing date",
            type: "text",
            name: "manufacturing_date",
            disabled: true,
            placeholder: "Enter Manufacturing date",
            required: true,
            col: 3,
        },
        {
            label: "Expiry Date",
            type: "text",
            name: "expiry_date",
            disabled: true,
            placeholder: "Enter Expiry Date",
            required: true,
            col: 3,
        },
        {
            label: "Quantity (number of bags)",
            type: "number",
            disabled: true,
            name: "number_of_bags",
            placeholder: "Enter Quantity (number of bags)",
            required: true,
            col: 3,
        },
        {
            label: "Volume (ml)",
            type: "text",
            disabled: true,
            name: "used_blood",
            placeholder: "Volume used",
            required: false,
            col: 2,
        },
        /*{
            label: "LSM Volumes per Bag",
            subLabel: "Enter LSM volumes for each bag",
            type: "textarea",
            name: "volume_in_each_bag",
            placeholder: "Enter LSM Volumes per Bag",
            disabled: false,
            manualValues: true,
            initialChildrenData: { bag_no: "", volume: "" },
            multipleField: true,
            hideDeleteIcon: true,
            hideAddIcon: true,
            col: 2,
            max: 100,
            isFirstPartField: true,
            children: (index) => [
                {
                    label: "Bag No",
                    type: "number",
                    name: `volume_in_each_bag.${index}.bag_no`,
                    required: true,
                    noQuery:true,
                    disabled: true,
                    placeholder: "Enter Bag No",
                    manualError: true,
                    isFirstPartField: true,
                },
                {
                    label: "Volume (ml)",
                    type: "number",
                    disabled: true,
                    noQuery:true,
                    name: `volume_in_each_bag.${index}.volume`,
                    required: true,
                    placeholder: "Enter Volume (ml)",
                    manualError: true,
                    isFirstPartField: true,
                },
            ],
        },*/
        {
            label: "COA",
            type: "radio",
            name: "has_coa_form",
            options: PrimaryOptions,
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Mode of Dispatch",
            type: "text",
            name: "mode_of_dispatch",
            placeholder: "Select Mode of Dispatch",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        { section: "Details of Data logger device in use" },
        {
            label: "Serial No",
            type: "text",
            disabled: true,
            name: "data_logger_serial_no",
            placeholder: "Enter Data Logger Serial No",
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Equipment ID",
            disabled: true,
            type: "select",
            name: "equipment_id",
            placeholder: "Select Equipment ID",
            options: equipmentOptions,
            col: 2,
            isFirstPartField: true,
        },
        { section: "Date of dispatch of Finished product" },
        {
            type: "date",
            label: "Date of dispatch",
            name: "date_of_dispatch_of_finished_product",
            placeholder: "Select Date of Dispatch",
            disabled: true,
            required: true,
            min: new Date(),
            inputClassName: "!py-[13px] !px-[13px]",
            col: 1,
            isFirstPartField: true,
        },
        { section: "Time and Temperature at the time of dispatch of the product in the transport box (24-hour format)" },
        {
            label: "Temperature at Dispatch (°C)",
            type: "number",
            name: "dispatch_temperature",
            placeholder: "Enter Temperature at Dispatch (°C)",
            isTempratureField: true,
            disabled: disabledAllItem,
            min: -80,
            required: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            label: "Time of Dispatch",
            type: "time",
            name: "dispatch_time",
            placeholder: "Select Time of Dispatch",
            disabled: disabledAllItem,
            required: true,
            col: 2,
            isFirstPartField: true,
        },
     
    ], [outboundInitialValues, disabledAllItem]);


    const outBoundFormValuesPart3 = useMemo(() => [
        {section: 'QA Acknowledgment'},
        {
            label: "Remarks",
            type: "textarea",
            name: "comment",
            placeholder: "Enter comment",
            disabled: !commentStatus,
            noQuery:true,
            required: true,
            col: 1,
        }
    ], [qaOutbondForm, commentStatus])

    const outBoundFormValuesPart2 = useMemo(() => [
        { section: "Dispatched By" },
        {
            type: "text",
            name: "dispatched_by_sign",
            label:'Dispatched By Name',
            placeholder: "Select Time of Dispatch",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            type: "text",
            label:'Dispatched Date',
            name: "dispatched_by_date",
            placeholder: "Select Time of Dispatch",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        { section: "Receipt & Verification (IA Warehouse/Logistics/QA)" },
        {
            name: "patient_details_verified",
            label: "Patient details verified",
            type: "radio",
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            required: true,
            col: 2,
        },
        {
            name: "receipt_date",
            label: "Date of receipt",
            type: "date",
            required: true,
            disabled: formik.values?.status == 2,
            placeholder: "Select Date of Receipt",
            min: new Date().toISOString().split("T")[0],
            max: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
            inputClassName: "!py-[13px] !px-[13px]",
            col: 2,
        },
        { section: "Physical integrity of transport box and product to be checked" },
        {
            name: "leakage_observed",
            label: "Leakage",
            type: "radio",
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            required: true,
            col: 2,
        },
        {
            name: "leakage_observed_comment",
            type: "textarea",
            label: "Leakage 's Comment",
            depend: "leakage_observed",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        {
            name: "broken_seal",
            label: "Broken Seal",
            type: "radio",
            required: true,
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            col: 2,
        },
        {
            name: "broken_seal_comment",
            type: "textarea",
            label: "Broken Seal 's Comment",
            depend: "broken_seal",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        {
            name: "broken_transport_box",
            label: "Broken Transport Box",
            type: "radio",
            required: true,
            disabled: formik.values?.status == 2,
            options: confirmationOptions,
            col: 2,
        },
         {
            name: "broken_transport_box_comment",
            type: "textarea",
            label: "Broken Transport Box 's Comment",
            depend: "broken_transport_box",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        { section: "Time and Temperature at the time of receipt of the finished product (24-hour format)" },
         {
                name: "temperature_excursion",
                label: "Temperature Excursion",
                type: "radio",
                required: true,
                options: confirmationOptions,
                disabled: formik.values?.status == 2,
                col: 2,
                isResolve: ["quality-check"],
         },
        {
            name: "temperature_excursion_comment",
            type: "textarea",
            label: "Temperature Excursion 's Comment",
            depend: "temperature_excursion",
            dependValue: "true",
            required: true,
            disabled: formik.values?.status == 2,
            col: 2,
        },
        {
            name: "receipt_temperature",
            label: "Excursion Temperature (°C)",
            type: "number",
            depend: "temperature_excursion",
            dependValue: "true",
            disabled: formik.values?.status == 2,
            required: true,
            placeholder: "Enter Excursion Temperature",
            isTempratureField: true,
            min: -80,
            max: 30,
            col: 2,
        },
             {
            name: "excursion_duration",
            label: "Excursion Duration (HH:MM)",
            type: "text",
            required: true,
            placeholder: "e.g. 48:30",
            disabled: formik.values?.status == 2,
            depend: "temperature_excursion",
            dependValue: "true",
            col: 2,
        },
        {
            name: "receipt_time",
            label: "Excursion Time",
            type: "time",
            depend: "temperature_excursion",
            dependValue: "true",
            disabled: formik.values?.status == 2,
            required: true,
            placeholder: "Select Excursion Time",
            col: 2,
        },
        { section: "Quantity received (number of bags)" },
        {
            name: "quantity_received",
            type: "number",
             label: "Number of Bags",
            disabled: formik.values?.status == 2,
            placeholder: "Enter Quantity Received",
            required: true,
            col: 1,
        },
        { section: "Received By" },
        {
            type: "text",
            name: "receipt_received_by_name",
             label: "Received By Name",
            placeholder: "Enter the receiver name",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            type: "text",
            name: "receipt_received_by_date",
             label: "Received Date",
            placeholder: "Enter the receiver sign & date",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        { section: "Verified By" },
        {
            type: "text",
            name: "receipt_verified_by_name",
             label: "Verified By Name",
            placeholder: "Enter the verifier name",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
        {
            type: "text",
            name: "receipt_verified_by_date",
            label: "Verified Date",
            placeholder: "Enter the verifier sign & date",
            required: true,
            disabled: true,
            col: 2,
            isFirstPartField: true,
        },
    ], [formik.values]);

    const formFieldsPrint = useMemo(() => {
        const fields = [];

        if (checkOutbondPart1Enable) {
            fields.push(...outBoundFormValuesPart1Print);
        }

        if (checkOutbondPart2Enable) {
            if (!checkOutbondPart1Enable) {
                fields.push(...outBoundFormValuesPart1Print);
            }
            fields.push(...outBoundFormValuesPart2Print);
        }
        if(qaOutbondForm){
          fields.push(...outBoundFormValuesPart3)
        }
        return fields;
    }, [checkOutbondPart1Enable, checkOutbondPart2Enable, outBoundFormValuesPart1Print, outBoundFormValuesPart2Print, qaOutbondForm]);


    // Combined form fields based on enabled parts
    const formFields = useMemo(() => {
        const fields = [];

        if (checkOutbondPart1Enable) {
            fields.push(...outBoundFormValuesPart1);
        }

        if (checkOutbondPart2Enable) {
            if (!checkOutbondPart1Enable) {
                fields.push(...outBoundFormValuesPart1);
            }
            fields.push(...outBoundFormValuesPart2);
        }
        if(qaOutbondForm){
          fields.push(...outBoundFormValuesPart3)
        }
        return fields;
    }, [checkOutbondPart1Enable, checkOutbondPart2Enable, outBoundFormValuesPart1, outBoundFormValuesPart2, qaOutbondForm]);

    // Memoized accordion toggle handler
    const handleAccordionToggle = useCallback(() => {
        setOutboundFormExpanded(prev => !prev);
    }, []);

    // Helper function to check field dependencies
    const shouldRenderField = useCallback((props, formikValues) => {
        if (props.noVisible) return false;

        if (props.depend) {
            const dependVal = formikValues[props.depend];
            const dependValues = props.dependValue?.includes(",")
                ? props.dependValue.split(",").map(v => v.trim())
                : [props.dependValue];

            if (Array.isArray(dependVal)) {
                return dependVal.some(val => dependValues.includes(`${val}`));
            } else {
                return dependValues.includes(`${dependVal}`);
            }
        }

        return true;
    }, []);

    // Render field component
    const renderField = useCallback((props, key) => {
        if (props.section) {
            return (
                <Grid key={key} item xs={12}>
                    <strong className="!pb-3">{props.section}</strong>
                </Grid>
            );
        }

        if (props.manualField) {
            return (
                <Grid key={key} item xs={12} className="flex align-items-baseline" />
            );
        }

        return (
            <Grid
                key={key}
                item
                xs={props.col && !props.children ? 12 / props.col : 12}
            >
                <FormControl
                    variant={props.variant ?? "standard"}
                    fullWidth={props.fullWidth ?? true}
                    className={`pl-3 pr-3 ${props.section ? "pt-3" : ""} ${props.className ?? ""}`}
                >
                    {props.label && props.children && (
                        <FormLabel
                            shrink
                            required={props.required}
                            className="text-[black]"
                        >
                            {props.label}
                        </FormLabel>
                    )}

                    {props.subLabel && (
                        <Typography
                            variant="span"
                            className="text-[#828282] text-[0.7rem]"
                        >
                            {props.subLabel}
                        </Typography>
                    )}

                    {!props.manualValues && !props.isObj && (
                        <div className="relative">
                            <FormikControl
                                formik={formik}
                                {...props}
                                className="mt-2"
                            />
                        </div>
                    )}

                    {props.children && (
                        props.isObj ? (
                            <div className="flex gap-3">
                                {props.children.map((subFieldProps, subFieldPropsIndex) => (
                                    <div key={subFieldPropsIndex} className="w-full relative">
                                        <FormikControl
                                            formik={formik}
                                            {...subFieldProps}
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <FormikArrayInBound props={props} formik={formik} />
                        )
                    )}
                </FormControl>
            </Grid>
        );
    }, [formik]);

    return (
        <Accordion
            className="w-100 !pt-2 !rounded-lg"
            sx={{
                borderLeft: `4px solid ${formik.values?.status != 2
                    ? "#FB9D2C"
                    : "#00B278"
                    }`,
            }}
            expanded={outbondFormExpanded}
            onChange={handleAccordionToggle}
        >
            <AccordionSummary
                expandIcon={
                    <div className="d-flex gap-3 align-items-center">
                        <DownIcon />
                    </div>
                }
                aria-controls="panel1-content"
                id="panel1-header"
            >
     <div className="flex w-full items-center justify-between mr-2">
      
        <div className="flex gap-2 items-center">
                <div className="flex flex-col gap-2">
                    <span className="font-bold text-[0.9rem]">Out-Bound Form</span>
                    {formik.values?.status != 2 ?
                        <p className="flex gap-2">
                            <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />
                            {formik.values?.status == 0 ? "In-Progress" : "Draft"}
                        </p> : <span className="flex gap-3" style={{ color: "#00B278" }}>
                            <CheckGreen Filled="#00B278" />
                            {"Completed"}
                        </span>}
                        </div>
                     </div>
                {/* RIGHT BUTTON */}
                    {isOutBoundPrint && <LoadingButton
                       type="button"
                       size="small"
                       onClick={handlePrintOutbound}
                       className="!w-[100px]"
                     >
                       Print
                     </LoadingButton>}
               
                   </div>
            </AccordionSummary>

            <AccordionDetails>
                <Divider />
                <form className="!mt-2" onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} className="mb-3">
                        {formFields.map((props, key) => {
                            if (!shouldRenderField(props, formik.values)) {
                                return null;
                            }
                            return renderField(props, key);
                        })}
                    </Grid>

                    <Grid container spacing={2}>
                        

                            {((qaOutbondForm && commentStatus) || ((role_id == 5 ||  role_slug === "project-manager") && checkOutbondPart2Enable && checkOutbondSubmitEnable && formik.values?.status == 1) || (checkOutbondPart1Enable && formik.values?.status == 0)) && 
                            <Grid item xs={12} className="justify-center flex mb-2 gap-2">
                                <LoadingButton
                                 onClick={() => setIsDraft(false)}
                                loading={isSubmitLoading}
                                type="submit"
                                variant="contained"
                            >
                                Submit
                            </LoadingButton>
                             {!(qaOutbondForm && commentStatus) && <LoadingButton
                               onClick={() => setIsDraft(true)}
                               type="submit"
                                variant="contained"
                                className="bg-[#ffa500]"
                            >
                                Save as Draft
                            </LoadingButton>}  </Grid>}
                        </Grid>
                  
                </form>
                 {allPrintData && (
                                <div style={{ display: "none" }}>
                                <QrAllPrintContent
                                  printData={allPrintData}
                                  ref={printContentAllRef}
                                  type={"outbound"}
                                /></div>
                            )}
            </AccordionDetails>
        </Accordion>
    );
};

export default OutBoundForm;